import { render, staticRenderFns } from "./redbag.vue?vue&type=template&id=5a45606f&"
import script from "./redbag.vue?vue&type=script&lang=js&"
export * from "./redbag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports